// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__jdL3o","button":"Counter_button__nl2d8","disabled":"Counter_disabled__dboBQ","number":"Counter_number__afitG"};